import type { OperationRun } from '@foodlista/trigger-vue'

export function visibleOperationIds(input: {
  envelopeIds: readonly string[]
  watchedIds: ReadonlySet<string>
}): Set<string> {
  const ids = new Set(input.envelopeIds)
  for (const id of input.watchedIds) {
    ids.add(id)
  }
  return ids
}

export function runsByVisibleOperationIds(
  runs: readonly OperationRun[],
  allowedIds: ReadonlySet<string>,
  resolveOperationId: (run: OperationRun) => string | null | undefined,
): Map<string, OperationRun> {
  const map = new Map<string, OperationRun>()
  for (const run of runs) {
    const operationId = resolveOperationId(run)
    if (operationId && allowedIds.has(operationId)) {
      map.set(operationId, run)
    }
  }
  return map
}
